const ROOT_SELECTOR = '[data-artists-category]';

function initCarousel(carousel) {
  if (carousel.dataset.inited === 'true') return;
  carousel.dataset.inited = 'true';

  const track = carousel.querySelector('[data-artist-track]');
  const prev = carousel.querySelector('[data-artist-prev]');
  const next = carousel.querySelector('[data-artist-next]');
  const counter = carousel.querySelector('[data-artist-count]');
  if (!track) return;

  const slides = Array.from(track.querySelectorAll('[data-artist-slide]'));
  if (!slides.length) return;

  const getStep = () => {
    const first = slides[0];
    if (!first) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
    return first.getBoundingClientRect().width + gap;
  };

  const updateCounter = () => {
    if (!counter) return;
    const first = slides[0];
    if (!first) return;
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
    const step = first.getBoundingClientRect().width + gap;
    const index = Math.min(slides.length, Math.max(1, Math.round(track.scrollLeft / step) + 1));
    counter.textContent = `${index}/${slides.length}`;
  };

  prev?.addEventListener('click', () => {
    track.scrollBy({ left: -getStep(), behavior: 'smooth' });
  });

  next?.addEventListener('click', () => {
    track.scrollBy({ left: getStep(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateCounter);
  });

  updateCounter();
}

function init(root) {
  root.querySelectorAll('[data-artist-carousel]').forEach(initCarousel);

  if (!root.__artistsObserver) {
    const observer = new MutationObserver(() => {
      root.querySelectorAll('[data-artist-carousel]').forEach(initCarousel);
    });
    observer.observe(root, { childList: true, subtree: true });
    root.__artistsObserver = observer;
  }
}

function initAll() {
  document.querySelectorAll(ROOT_SELECTOR).forEach((root) => init(root));
}

document.addEventListener('DOMContentLoaded', initAll);
document.addEventListener('shopify:section:load', (event) => {
  const root = event.target?.querySelector?.(ROOT_SELECTOR);
  if (root) init(root);
});